import { createSelector } from '@reduxjs/toolkit';
import { Territory } from '../models/territories';
import { User } from '../models/user';
import { AppState, territorySelector, userSelector } from '../store/store';




export const selectTerritoriesAdministration = createSelector([
    (state: AppState) => territorySelector.selectAll(state),
    (state: AppState) => userSelector.selectById(state, state.device?.user?.id ?? 0),
], (territories: Territory[], user?: User) => {
    if (user?.isAdmin) return territories;
    else {
        return territories.filter(p => p.franchiseId == user?.franchiseId);
    }
});
